import { isMac } from '@gonfalon/browser-platform/isMac';

export function physicalKeyCodeToFriendlyKeyName(code: string): string {
  // KeyA → A, KeyB → B, etc. (uppercase for display)
  if (code.startsWith('Key')) {
    return code.slice(3).toLowerCase();
  }

  // Digit0 → 0, Digit1 → 1, etc.
  if (code.startsWith('Digit')) {
    return code.slice(5);
  }

  // Arrow keys
  if (code.startsWith('Arrow')) {
    return code.slice(5); // ArrowUp → Up, ArrowDown → Down
  }

  // Modifiers (platform-agnostic)
  if (code.startsWith('Meta')) {
    return isMac() ? '⌘' : 'Meta';
  }
  if (code.startsWith('Control')) {
    return isMac() ? '⌃' : 'Ctrl';
  }
  if (code.startsWith('Alt')) {
    return isMac() ? '⌥' : 'Alt';
  }
  if (code.startsWith('Shift')) {
    return isMac() ? '⇧' : 'Shift';
  }

  // Common special keys
  switch (code) {
    case 'Escape':
      return 'Esc';
    case 'Enter':
      return 'Enter';
    case 'Space':
      return 'Space';
    case 'Backspace':
      return 'Backspace';
    case 'Delete':
      return 'Delete';
    case 'Tab':
      return 'Tab';

    // Punctuation
    case 'Slash':
      return '/';
    case 'Period':
      return '.';
    case 'Comma':
      return ',';
    case 'Semicolon':
      return ';';
    case 'Quote':
      return "'";
    case 'BracketLeft':
      return '[';
    case 'BracketRight':
      return ']';
    case 'Backslash':
      return '\\';
    case 'Minus':
      return '-';
    case 'Equal':
      return '=';
    case 'Backquote':
      return '`';
    default:
      return code;
  }
}
